import { ICheckableObject } from "../../../../../../domain/editableFormat/objects";
import { ICheckableObjectBean } from "../../../beans/objects";

export class CategoryNameTranslator {
  from(bean: ICheckableObjectBean): string {
    return bean["@item-name"];
  }

  to(object: ICheckableObject): string {
    return object.categoryName;
  }
}
